export default __webpack_public_path__ + "static/media/innovate.52587fdf.jpeg";